/* eslint no-undef: 0 */
'use strict';
exports.default = exports;

const _ = require('lodash');

// function printMatDebug(source, target, mat) {
//   let text = ' \t \t';
//   for (let j = 0; j <= target.length; j++) {
//     text+= (target[j]|| ' ')+'\t';
//   }
//   text+= '\n';
//   for (let i = 0; i <= source.length; i++) {
//     text+= ((i>0?source[i-1]:' ')|| ' ')+'\t';
//     for (let j = 0; j <= target.length; j++) {
//       text+= (mat[i][j] || ' ')+'\t';
//     }
//     text+= '\n';
//   }
//   console.log(text);
// }

// levenshtein alterado para substring, nesse algoritmo a ordem importa
exports.fcmLevenshtein = function(source, target) {
  const result = []; // This is going to be a matrix. The result we're looking for can be found by flood-filling it.
  let i, j;

  // Let's fill the first line of the matrix with distances from each substring of the source to the empty string.
  for (i = 0; i <= source.length; i++) {
    result.push([i]);
  }

  // Same as above, but for a column. Also, the first element of the first column is already filled with a zero, hence j = 1.
  for (j = 1; j <= target.length; j++) {
    result[0].push(0);
  }

  for (i = 1; i <= source.length; i++) {
    for (j = 1; j <= target.length; j++) {

      // the element in the iteration doesn't exist yet. Let's create it.
      result[i].push(0);

      // Now let's get an edit distance between two characters.
      if (source[i-1] === target[j-1]) {

        // Notice how, for a comparison between two equal strings, the diagonal will be filled with zeroes.
        result[i][j] = result[i-1][j-1];
      } else {

        // Different characters. The formulae for edit distances are shown below.
        let minimum = Math.min(
          result[i-1][j] + 1, // This means we can bring the target string closer to the source one with a character deletion
          result[i][j-1] + 1  // Same as above, but with a character insertion
        );

        minimum = Math.min(
          minimum,
          result[i-1][j-1] + 1 // This means that we can bring the target closer to the source by means of a character change.
        );
        result[i][j] = minimum;
      }
    }
  }

  let fcmMin = target.length;
  for (j = 1; j <= target.length; j++) {
    if(fcmMin>result[source.length][j]) {
      fcmMin = result[source.length][j];
    }
  }
  //  printMatDebug(source, target, result);
  return fcmMin;

  // The actual distance we're looking for is the value stored in the lower right corner of the matrix.
  // return result[source.length][target.length];
};

exports.levenshtein = function(source, target) {
  const result = []; // This is going to be a matrix. The result we're looking for can be found by flood-filling it.
  let i, j;

  // Let's fill the first line of the matrix with distances from each substring of the source to the empty string.
  for (i = 0; i <= source.length; i++) {
    result.push([i]);
  }

  // Same as above, but for a column. Also, the first element of the first column is already filled with a zero, hence j = 1.
  for (j = 1; j <= target.length; j++) {
    result[0].push(0);
  }

  for (i = 1; i <= source.length; i++) {
    for (j = 1; j <= target.length; j++) {

      // the element in the iteration doesn't exist yet. Let's create it.
      result[i].push(0);

      // Now let's get an edit distance between two characters.
      if (source[i-1] === target[j-1]) {

        // Notice how, for a comparison between two equal strings, the diagonal will be filled with zeroes.
        result[i][j] = result[i-1][j-1];
      } else {

        // Different characters. The formulae for edit distances are shown below.
        let minimum = Math.min(
          result[i-1][j] + 1, // This means we can bring the target string closer to the source one with a character deletion
          result[i][j-1] + 1  // Same as above, but with a character insertion
        );

        minimum = Math.min(
          minimum,
          result[i-1][j-1] + 1 // This means that we can bring the target closer to the source by means of a character change.
        );
        result[i][j] = minimum;
      }
    }
  }

  //  printMatDebug(source, target, result);
  // The actual distance we're looking for is the value stored in the lower right corner of the matrix.
  return result[source.length][target.length];
};



// É esperado as strings em lowercase e sem espaço no inicio e no fim
// let score = stringUtils.fcmlevenshteinNormalizeScore('start Buc', 'cafe starbucks - brasil');
// source.toLowerCase().trim();
exports.fcmlevenshteinNormalizeScore = function(source, target) {
  if(!source) {return 0;}
  if(!target) {return 0;}
  let cont = 0;
  let scoreSearch = source.split(' ').reduce(function(o, term) {
    if(!term) {
      return o;
    }
    cont++;
    return o+(1-(exports.fcmLevenshtein(term, target)/term.length));
  }, 0);
  scoreSearch /= cont || 1;
  return scoreSearch;
};

exports.fcmlevenshteinNormalizeScoreOrdered = function(source, target) {
  if(!source) {return 0;}
  if(!target) {return 0;}
  return 1-(exports.fcmLevenshtein(source, target)/Math.min(source.length,target.length));
};

exports.levenshteinNormalizeScoreOrdered = function(source, target) {
  if(!source) {return 0;}
  if(!target) {return 0;}
  return 1-(exports.levenshtein(source, target)/Math.min(source.length,target.length));
};


exports.toTitleCase = (phrase) => {
  if(!phrase) {return '';}
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};


exports.username = (phrase) => {
  if (!phrase) {
    return '';
  }
  phrase =_.deburr(phrase);

  return phrase.replace(/[^A-Za-z\d_-]/g, '');
};

exports.deburr = (txt) => {
  return _.deburr(txt||'').toLowerCase().trim();
};

exports.deburrCase = (txt) => {
  return _.deburr(txt||'').trim();
};

exports.deburrMatchOcr = (txt) => {
  return _.deburr(txt||'').toLowerCase().trim();
};

exports.deburrSlug = (txt) => {
  return (txt ||'').replace(/[^\dA-Za-z\-\/_]/g, '').trim();
};

exports.deburrCpf = (txt) => {
  return (txt||'').replace(/[^\d]/g, '').trim();
};

exports.deburrDocument = (txt) => {
  return (txt||'').replace(/[^\d]/g, '').trim();
};

/**
 * CPF/CNPJ com pontuação, para exibição — o inverso do `deburrDocument`.
 *
 * O banco guarda documento SÓ COM DÍGITOS (é o que o casamento por documento e as queries
 * `where('cnpj', '==')` de convênios, hospitais e instituições esperam); a pontuação é
 * responsabilidade de quem imprime. Mais de 11
 * dígitos formata como CNPJ, exatamente 11 como CPF; qualquer outro tamanho volta como veio, para
 * não mascarar um documento inválido como se fosse válido.
 *
 * @param {string} raw documento, com ou sem formatação
 * @returns {string}
 */
exports.formatDocument = (raw) => {
  const d = String(raw ?? '').replace(/\D/g, '');
  if (d.length > 11) {
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
  }
  if (d.length === 11) {
    return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9, 11)}`;
  }
  return String(raw ?? '');
};


exports.clearName = (txt) => {
  return String(txt || '').replaceAll('\t\n\r', '').trim();
};

exports.maskCPF = (text) => {
  const t = exports.deburrCpf(text||'');
  return `${t[0]||''}${t[1]||''}${t[2]||''}.${t[3]||''}${t[4]||''}${t[5]||''}.${t[6]||''}${t[7]||''}${t[8]||''}-${t[9]||''}${t[10]||''}`;
};

exports.getSearch = (array) => {
  return exports.deburr(array.filter(a=>!!a).join(' '));
};

exports.shuffle = function(input) {
  const a = input.split(''),
    n = a.length;

  for(let i = n - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = a[i];
    a[i] = a[j];
    a[j] = tmp;
  }
  return a.join('');
};


exports.getFragment = function(key, numberOfFragments) {
  let sum = 0;
  for(const i in key) {
    sum+=(key.charCodeAt(i)||0);
  }
  return sum%numberOfFragments;
};

exports.getFragmentMult = function(key, numberOfFragments) {
  let sum = 0;
  for(const i in key) {
    sum+=(key.charCodeAt(i)||0)*i*21;
  }
  return sum%numberOfFragments;
};

exports.validateCpf = function(value) {
  if (!value) {
    return true;
  }
  value = exports.deburrCpf(value);

  let sum;
  let rest;
  let returnInvalid = false;
  sum = 0;
  if (value === '00000000000')
    returnInvalid = true;

  for (let i = 1; i <= 9; i++)
    sum = sum + parseInt(value.substring(i - 1, i)) * (11 - i);

  rest = (sum * 10) % 11;

  if ((rest === 10) || (rest === 11))
    rest = 0;
  if (rest !== parseInt(value.substring(9, 10)))
    returnInvalid = true;

  sum = 0;
  for (let i = 1; i <= 10; i++)
    sum = sum + parseInt(value.substring(i - 1, i)) * (12 - i);

  rest = (sum * 10) % 11;

  if ((rest === 10) || (rest === 11))
    rest = 0;
  if (rest !== parseInt(value.substring(10, 11)))
    returnInvalid = true;

  return !returnInvalid;
};

exports.fallbackCopyTextToClipboard = function(text) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');
    const msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
};
exports.copyTextToClipboard = async function(text) {
  if(typeof navigator==='undefined') {
    console.error('Async: Could not copy text!');
    return false;
  }
  if (!navigator.clipboard) {
    return exports.fallbackCopyTextToClipboard(text);
  }
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch(err) {
    console.error('Async: Could not copy text: ', err);
  }
  return false;
};

exports.json2csv = function(items) {
  let ret = '';
  for(const row of items) {
    for(const itemIndex in row) {
      let value = row[itemIndex];
      if(typeof value==='string') {
        value = '"'+value+'"';
      }
      ret += value + ';';
    }
    ret += '\n';
  }
  return ret;
};


exports.json2csv2 = function(items, header, replacer) {
  if(!replacer) {
    replacer = (key, value) => value === null ? '' : (typeof value!=='string'?value:value.replace('"', '\''));
  }
  return [
    header.join(','), // header row first
    ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
  ].join('\r\n');
};


exports.makeId = function(length) {
  let result           = '';
  const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};



exports.processNodeHtml = function(node, result, limit=10) {
  for(const el of node.childNodes || []) {
    if(el.nodeName==='#text' || el.nodeName==='#TEXT') {
      result.words += el.data?.split(' ')?.length || 0;
    }
    if(el.nodeName.startsWith('H') || el.nodeName.startsWith('h')) {
      const slug = exports.deburrSlug(el.textContent)+ '_title';
      let sufix = '';
      if(result.slugs[slug]) {
        result.slugs[slug]++;
        sufix = result.slugs[slug];
      }
      else {
        result.slugs[slug] = 1;
      }
      if(!el.id) {
        el.id = slug+sufix;
      }
      result.topics.push({
        label: el.innerHTML,
        id: slug+sufix
      });
    }
    if(limit>0) {
      exports.processNodeHtml(el, result, limit-1);
    }
  }
};

exports.processHtml = function(html, result) {
  const div = document.createElement('div');
  div.innerHTML = html?.trim() || '';
  exports.processNodeHtml(div, result);
};

exports.upperCaseStrings = function(form, keys={}) {
  if (typeof form === 'string') {
    return form.toUpperCase();
  }
  let aux = _.cloneDeep(form);
  const _upperCaseStrings = (aux, upper) => {
    if (typeof aux === 'string' && upper) {
      return aux.toUpperCase();
    } else if (typeof aux === 'object') {
      for (const index2 in aux) {
        aux[index2] = _upperCaseStrings(aux[index2], !!keys[index2]);
      }
    }
    return aux;
  };
  aux = _upperCaseStrings(aux, false);
  return aux;
};

exports.sanitizedText = (text) => {
  return text.replace(/[\/\\:*?"<>|]/g, '-');
};
